/* tslint:disable */
/* eslint-disable */
/**
 * Credit API
 * API for banking integrations
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface Bank
 */
export interface Bank {
    /**
     * 
     * @type {number}
     * @memberof Bank
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof Bank
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Bank
     */
    'slug'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Bank
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Bank
     */
    'provider'?: BankProviderEnum;
}

export const BankProviderEnum = {
    credit: 'CREDIT',
    moneytree: 'MONEYTREE'
} as const;

export type BankProviderEnum = typeof BankProviderEnum[keyof typeof BankProviderEnum];


